import { useState, useEffect, useRef } from 'react';

export const useOnScreen = (options) => {
	const ref = useRef(null);
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		if (!ref.current || isVisible) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setIsVisible(true);
					observer.disconnect();
				}
			},
			options
		);

		observer.observe(ref.current);

		return () => {
			observer.disconnect();
		};
	}, [ref, options, isVisible]);

	return [ref, isVisible];
};
